"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TreeMenu = _ref => {
  let {
    menuItems,
    rootMenuItem,
    className,
    selectedId,
    isExpanded
  } = _ref;
  const getMenuItemList = menuItemChildren => {
    let items = [];
    const menuItemList = menuItemChildren && menuItemChildren.children ? menuItemChildren.children : menuItemChildren;
    if (typeof menuItemList !== 'undefined') {
      for (let i = 0; i < menuItemList.length; i += 1) {
        items.push(menuItemList[i]);
        if (typeof menuItemList[i].children !== 'undefined') {
          items = items.concat(getMenuItemList(menuItemList[i].children));
        }
      }
    }
    return items;
  };
  const getMenuPath = (treeMenuArg, id, stopAtMenuItemName) => {
    const menuItemsTemp = getMenuItemList(treeMenuArg.children);
    const path = [];
    let currentMenuItem = menuItemsTemp.find(menuItem => menuItem.id === id);
    let counter = 0;
    const max = 100;
    const stopName = stopAtMenuItemName || 'Main-Menu-Links';
    while (currentMenuItem && counter < max) {
      path.push(currentMenuItem);
      const currentMenuItemSafe = {
        ...currentMenuItem
      };
      currentMenuItem = menuItemsTemp.find(menuItem => menuItem.id === currentMenuItemSafe.parentId && menuItem.name !== stopName);
      counter++;
    }
    return path.reverse();
  };
  const getMenuItemCheckSum = menuItemsArg => {
    const menuList = getMenuItemList(menuItemsArg);
    const menuIds = menuList.map(item => item.id);
    return menuIds.join('-');
  };
  const findMenuSubTree = (m, n) => {
    if (m.id === n) {
      return m;
    }
    if (m.children && m.children.length > 0) {
      for (let i = 0; i < m.children.length; i++) {
        const c = findMenuSubTree(m.children[i], n);
        if (c !== undefined) {
          return c;
        }
      }
    }
    return undefined;
  };
  const toggleMenu = (treeMenuArg, n) => {
    const m = findMenuSubTree(treeMenuArg, n);
    m.isExpanded = !m.isExpanded;
  };
  const expandMenu = (treeMenuArg, n) => {
    const m = findMenuSubTree(treeMenuArg, n);
    m.isExpanded = true;
  };
  const [treeMenu, setTreeMenu] = (0, _react.useState)({
    ...menuItems
  });
  const [renderCount, setRenderCount] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    const calcMenuItems = () => {
      let results = menuItems;
      const frozenTreeMenu = localStorage.getItem(`treeMenu_${menuItems.id}`);
      if (frozenTreeMenu) {
        const thawedTreeMenu = JSON.parse(frozenTreeMenu);
        const checkSumThawed = getMenuItemCheckSum(thawedTreeMenu);
        const checkSumArg = getMenuItemCheckSum(menuItems);
        if (checkSumThawed === checkSumArg) {
          results = thawedTreeMenu;
        }
      }
      if (isExpanded && !frozenTreeMenu) {
        const menuList = getMenuItemList(results);
        menuList.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          item.isExpanded = true;
        });
      }
      const menuPath = getMenuPath(results, selectedId);
      menuPath.forEach(item => expandMenu(results, item.id));
      localStorage.setItem(`treeMenu_${menuItems.id}`, JSON.stringify(results));
      setTreeMenu(results);
    };
    calcMenuItems();
  }, [selectedId, isExpanded]);
  const handleToggleMenu = (treeMenuArg, n) => {
    toggleMenu(treeMenuArg, n);
    localStorage.setItem(`treeMenu_${menuItems.id}`, JSON.stringify(treeMenuArg));
    setTreeMenu(treeMenuArg);
    setRenderCount(renderCount + 1);
  };
  const drawMenu = (m, depth) => /*#__PURE__*/_react.default.createElement("div", {
    key: `tree-menu-${m.id}`,
    className: `tree-menu-block tree-menu-block-${depth}`
  }, depth > 0 && m.children && m.children.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: m.isExpanded || depth === 0 ? 'tree-menu-item tree-menu-item-open' : 'tree-menu-item tree-menu-item-closed'
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "menuitem",
    className: "tree-menu-icon is-pulled-left",
    onClick: () => handleToggleMenu(treeMenu, m.id),
    onKeyUp: () => handleToggleMenu(treeMenu, m.id),
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, m.isExpanded ? 'folder_open' : 'folder')), /*#__PURE__*/_react.default.createElement("div", {
    role: "menuitem",
    className: "tree-menu-label",
    onClick: () => handleToggleMenu(treeMenu, m.id),
    onKeyUp: () => handleToggleMenu(treeMenu, m.id),
    tabIndex: 0
  }, m.name)), depth > 0 && !m.children || m.children.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: `tree-menu-item tree-menu-item-link ${m.id === selectedId ? 'is-active' : ''}`
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: m.path,
    activeClassName: "is-active"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tree-menu-icon is-pulled-left"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "article")), /*#__PURE__*/_react.default.createElement("div", {
    className: "tree-menu-label"
  }, m.name))), (m.isExpanded || depth === 0) && m.children && m.children.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", null, m.children.map(child => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `treechild_${child.id}`
  }, drawMenu(child, depth + 1)))) : null);
  const elements = [];
  if (treeMenu !== undefined) {
    const treeMenuChildren = rootMenuItem ? findMenuSubTree(treeMenu, rootMenuItem.name) : treeMenu;
    elements.push( /*#__PURE__*/_react.default.createElement("div", {
      key: `tree-menu-root-${treeMenu.id}`,
      className: (0, _classnames.default)('tree-menu', className)
    }, drawMenu(treeMenuChildren, 0)));
  }
  return elements;
};
const propTypeMenuItem = _propTypes.default.shape({
  id: _propTypes.default.number,
  component: _propTypes.default.string,
  content: _propTypes.default.string,
  customizationId: _propTypes.default.number,
  icon: _propTypes.default.string,
  image: _propTypes.default.string,
  menuItemTypeCode: _propTypes.default.number,
  name: _propTypes.default.string,
  pageTitle: _propTypes.default.string,
  parentId: _propTypes.default.number,
  path: _propTypes.default.string,
  siteId: _propTypes.default.number,
  sortOrder: _propTypes.default.number,
  theme: _propTypes.default.string,
  title: _propTypes.default.string,
  tutorialUrl: _propTypes.default.string,
  visible: _propTypes.default.bool
});
TreeMenu.propTypes = {
  menuItems: _propTypes.default.oneOfType([propTypeMenuItem, _propTypes.default.arrayOf(propTypeMenuItem)]),
  isExpanded: _propTypes.default.bool,
  rootMenuItem: propTypeMenuItem,
  className: _propTypes.default.string,
  selectedId: _propTypes.default.number
};
TreeMenu.defaultProps = {
  siteMenuTree: undefined
};
var _default = exports.default = (0, _core.withUiProps)(TreeMenu);
//# sourceMappingURL=TreeMenu.js.map